import {
  ACCEPT_INVITATION_REQUEST,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAILURE,
  GET_INVITATION_FAILURE,
} from 'constants/action_types'
import { ACCEPT_INVITE_PAGE } from '../pages'

const defaultAcceptInviteState = {
  isAccepting: false,
  hasError: false,
  acceptError: null,
  invitationFound: true,
}

export default function acceptInviteReducer(
  state,
  { type, payload: { error, invitationToken } = {} }
) {
  switch (type) {
    case ACCEPT_INVITE_PAGE:
      return {
        ...state,
        invitationToken,
      }
    case ACCEPT_INVITATION_REQUEST:
      return {
        ...state,
        isAccepting: true,
        hasError: false,
        acceptError: null,
      }
    case ACCEPT_INVITATION_SUCCESS:
      return {
        ...state,
        isAccepting: false,
        hasError: false,
      }
    case ACCEPT_INVITATION_FAILURE:
      return {
        ...state,
        isAccepting: false,
        hasError: true,
        acceptError: error,
      }
    case GET_INVITATION_FAILURE:
      return {
        ...state,
        invitationFound: false,
      }
    default:
      return state || defaultAcceptInviteState
  }
}
